import CoreResize from '../../mixins/core-resize'

import AppModal from '../app-modal'
import AppBtn from '../app-btn'
import AppBtnRadio from '../app-btn-radio'


import URL from '../../../config.url'
import Gateway from '../../utils/global/Gateway'


function pushToGTM(data)
{
    if (window.dataLayer)
    {
        window.dataLayer.push(data)
    }
    else
    {
        console.error('Google Tag Manager: dataLayer not defined')
    }
}

/**
 * Calculate a 32 bit FNV-1a hash
 * Found here: https://gist.github.com/vaiorabbit/5657561
 * Ref.: http://isthe.com/chongo/tech/comp/fnv/
 * @author https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
 *
 * @param {string} str the input value
 * @param {boolean} [asString=false] set to true to return the hash value as
 *     8-digit hex string instead of an integer
 * @param {integer} [seed] optionally pass the hash of the previous chunk
 * @returns {integer | string}
 */
function hashFnv32a(str, asString = false, seed = 0x811c9dc5)
{
    /* jshint bitwise:false */
    let hval = seed

    for (let i = 0; i < str.length; i++)
    {
        hval ^= str.charCodeAt(i)
        hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24)
    }
    if (asString)
    {
        // Convert to 8 digit hex string
        return ('0000000' + (hval >>> 0).toString(16)).substr(-8)
    }

    return hval >>> 0
}


export default
{
    name: 'app-modal-register',

    mixins:
    [
        CoreResize
    ],

    components:
    {
        AppModal,
        AppBtn,
        AppBtnRadio
    },

    props:
    {
        contentGlobal: { type: Object },
        typeSlug: { type: String, default: 'default' },
        observeId: { type: String, default: '' }
    },

    data()
    {
        return {
            state: 'check',
            url: URL,

            // RESPOND
            respond: {
                title: '',
                description: ''
            },

            // FORM
            terms: false,
            newsletter: false,
            errors: {
                username: '',
                nationality: '',
                password: '',
                confirm: '',
                email: '',
                captcha: '',
                terms: '',
                newsletter: ''
            },
            nationality: ''
        }
    },

    mounted()
    {
        this._bgElmt = this.$el.querySelector('.c-modal-play__bg')
        this.$el.addEventListener('scroll', this._scrollPopin)

        const termsLinkElmt = this.$el.querySelector('.c-link--terms>a')
        const newsLinkElmt = this.$el.querySelector('.c-link--newsletter>a')

        if (termsLinkElmt)
        {
            termsLinkElmt.href = this.$root.getPageURLFromID('terms')
            termsLinkElmt.onclick = event =>
            {
                event.preventDefault()
                this.$root.changePage(this.$root.getPageURLFromID('terms'))
                return false
            }
        }

        if (newsLinkElmt)
        {
            newsLinkElmt.href = URL.page.policy
            newsLinkElmt.onclick = event =>
            {
                event.preventDefault()
                this.$root.changePage(URL.page.policy)
                return false
            }
        }
    },

    destroyed()
    {
        this.$el.removeEventListener('scroll', this._scrollPopin)
    },

    methods:
    {
        onResized()
        {
            this._scrollPopin()
        },

        pushBuyToGTM(href)
        {
            if (window.dataLayer)
            {
                window.dataLayer.push({
                    event: 'gfinity.external',
                    'gfinity.external.type': 'click',
                    'gfinity.external.resource': href
                })
            }
            else
            {
                console.error('Google Tag Manager: dataLayer not defined')
            }
        },

        _scrollPopin()
        {
            const posY = this.$el.scrollTop
            this._bgElmt.style.transform = 'translateY(' + posY + 'px) translateZ(0)'
        },

        _close()
        {
            this.$root.closeModalPlay()
        },

        _check()
        {
            const email = this.$el.querySelector('input[name=email]').value

            const postData = {
                email,
                type: this.contentGlobal.popinPlaying.custom[this.typeSlug].typeId
            }
            if (this.observeId.trim() !== '')
            {
                postData.observeId = this.observeId
            }


            this.saved = { email }

            Gateway.getInstance().send(
                this.$root.getAPIURLWithLangFromID('userCheck'),
                this._onCheked,
                this._onError,
                { },
                postData)
        },

        _send()
        {
            const username = this.$el.querySelector('input[name=username]').value
            const nationality = this.$el.querySelector('select[name=nationality]').value
            const password = this.$el.querySelector('input[name=password]').value
            const passwordConfirm = this.$el.querySelector('input[name=confirm]').value

            console.log('_send', 'nationality', nationality)

            let captcha = ''
            try
            {
                const grecaptcha = window.grecaptcha
                if (grecaptcha)
                {
                    captcha = grecaptcha.getResponse(this._recaptcha)
                }
                else
                {
                    console.error('Google Captcha (grecaptch) getResponse() error!')
                }
            }
            catch (error)
            {
                captcha = ''
                console.error('Google Captcha (grecaptch) error:', error.message)
            }


            const postData = {
                username,
                nationality,
                captcha,
                password,
                email: this.saved.email,
                password_confirm: passwordConfirm,
                terms: this.terms,
                no_marketing: !this.newsletter,
                type: this.contentGlobal.popinPlaying.custom[this.typeSlug].typeId
            }
            if (this.observeId.trim() !== '')
            {
                postData.observeId = this.observeId
            }

            this.saved = postData


            Gateway.getInstance().send(
                this.$root.getAPIURLWithLangFromID('userRegister'),
                this._onSended,
                this._onError,
                { },
                postData)
        },


        _initCaptcha()
        {
            const grecaptcha = window.grecaptcha
            if (grecaptcha)
            {
                const captchaContainer = this.$el.querySelector('.is-captcha')
                this._recaptcha = grecaptcha.render(
                    captchaContainer,
                    // https://developers.google.com/recaptcha/docs/display#render_param
                    {
                        sitekey: '6LdZxSMUAAAAADKk_EJ9RVGZhXwkT2cXs_qE4q75',
                        theme: 'dark '
                    }
                )
            }
            else
            {
                console.error('Google Captcha (grecaptch) error!')
            }
        },


        _onCheked(data)
        {
            const errors = this.errors

            if (data.success)
            {
                errors.email = ''
                errors.captcha = ''

                if (data.registered)
                {
                    this.state = this.typeSlug === 'default' ? 'success3' : 'success1'

                    pushToGTM({
                        event: 'gfinity.register',
                        'gfinity.register.type': 'gfinity_elite_series',
                        'gfinity.register.user.id': hashFnv32a(this.saved.email)
                    })
                }
                else
                {
                    this.state = 'form'
                    this.$nextTick(this._initCaptcha)
                }
            }
            else if (data.data && data.data.error && data.data.error.validation)
            {
                const validation = data.data.error.validation

                errors.email = validation.email || ''
                errors.captcha = validation.captcha || ''


                this.state = 'check'
            }
            else
            {
                this._onError()
            }
        },

        _onSended(data)
        {
            const errors = this.errors

            if (data.success)
            {
                errors.password = ''
                errors.username = ''
                errors.nationality = ''
                errors.confirm = ''
                errors.email = ''
                errors.captcha = ''
                errors.terms = ''
                errors.newsletter = ''

                this.state = this.typeSlug === 'default' ? 'success4' : 'success2'

                pushToGTM({
                    event: 'gfinity.register',
                    'gfinity.register.type': 'gfinity_elite_series',
                    'gfinity.register.user.id': hashFnv32a(this.saved.email)
                })
            }
            else if (data.data && data.data.error && data.data.error.validation)
            {
                const validation = data.data.error.validation

                errors.password = validation.password || ''
                errors.username = validation.username || ''
                errors.nationality = validation.nationality || ''
                errors.confirm = validation.password_confirm || ''
                errors.email = validation.email || ''
                errors.captcha = validation.captcha || ''
                errors.terms = validation.terms || ''
                errors.newsletter = validation.newsletter || ''

                try
                {
                    const grecaptcha = window.grecaptcha
                    if (grecaptcha)
                    {
                        grecaptcha.reset(this._recaptcha)
                    }
                    else
                    {
                        console.error('Google Captcha (grecaptch) reset() error!')
                    }
                }
                catch (error)
                {
                    console.error('Google Captcha (grecaptch) error:', error.message)
                }

                this.state = 'form'
            }
            else
            {
                this._onError()
            }
        },

        _onError()
        {
            this.state = 'error'
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-modal-register/script.js